import { render, staticRenderFns } from "./EditReward.vue?vue&type=template&id=71ac3444&scoped=true"
import script from "./EditReward.vue?vue&type=script&lang=js"
export * from "./EditReward.vue?vue&type=script&lang=js"
import style0 from "./EditReward.vue?vue&type=style&index=0&id=71ac3444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac3444",
  null
  
)

export default component.exports